import React from 'react'
import '../styles/icon.css'

export default function Icon(props) {
    
    return(
        
        <div class="iconDiv">

            <img class="iconSize" src={props.src}></img>
    
        </div>
    
    )
    
}